import { makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import { models } from 'powerbi-client';
import { PowerBIEmbed } from "powerbi-client-react";
import React, { useEffect, useState } from "react";
import { useGlobalSnackbar } from "../../contexts/SnackbarContext";
import { useUser } from "../../contexts/UserContextProvider";
import useApi from "../../hooks/useApi";
import Loading from "../Loading";
import { useTranslation } from "react-i18next";


const useStyles = makeStyles(theme => ({
    welcome: {
        display: 'grid',
        placeItems: 'center',
        padding: '1rem',
        gap: '1rem',
        fontSize: '.9rem',
        marginBottom: '.5rem',
        textAlign: 'center',
    },
    title: {
        fontWeight: "bold",
        fontSize: "1.3rem",
    },
    embedWrapper: {
        position: "relative",
    },
    powerBiDashboard: {
        "& > iframe": {
            minHeight: '70vh',
            border: 0,
        }
    }
}));

const Dashboard = () => {
      const { t, i18n } = useTranslation(["components", "common"]);
    const api = useApi();
    const [user] = useUser();
    const setGlobalSnackbar = useGlobalSnackbar();
    const styles = useStyles();
    const [loading, setLoading] = useState(false);
    const [powerBiReport, setPowerBiReport] = useState({});
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("sm"));

    useEffect(() => {
        setLoading(true);
    }, [matches]);

    useEffect(() => {
        if (!user) return;
        (async () => {
            setLoading(true);
            const res = await api(`embedinfo/getembedinfo`, "GET", null, null, false, false);
            if (res.ok !== false) {
                setPowerBiReport(res);
                return;
            }
            setGlobalSnackbar({
                open: true,
                severity: "error",
                message: `${t("common:errors.dashboard")}`
            });
        })();
    }, [user]);

    const language = (i18n.resolvedLanguage || i18n.language || "it").split("-")[0];

    return <div>
        <div className={styles.welcome}>
            <p className={styles.title}>{user?.profile?.name} {user?.profile?.lastName}{t("components:dashboard.title")}</p>
            <p>{t("components:dashboard.subtitle")}</p>
        </div>
        <div className={styles.embedWrapper}>
            <Loading bg="white" loading={loading} />
            <PowerBIEmbed
                key={matches}
                embedConfig={{
                    embedUrl: powerBiReport?.EmbedReport?.[0]?.EmbedUrl,
                    id: powerBiReport?.EmbedReport?.ReportId,
                    type: 'report',   // Supported types: report, dashboard, tile, visual and qna
                    accessToken: powerBiReport?.EmbedToken?.Token,
                    tokenType: models.TokenType.Embed,
                    settings: {
                        localeSettings: {
                            language,
                            formatLocale: language
                        },
                        filterPaneEnabled: false,
                        layoutType: matches ? undefined : models.LayoutType.MobilePortrait,
                    },
                    filters: [{
                        $schema: "http://powerbi.com/product/schema#advanced",
                        target: {
                            table: "merge_therapist",
                            column: "therapist.Document.ClinicCode"
                        },
                        logicalOperator: "And",
                        conditions: [
                            {
                                operator: "Is",
                                value: user?.profile?.clinicCode,
                            }
                        ],
                        filterType: models.FilterType.AdvancedFilter
                    }, {
                        $schema: "http://powerbi.com/product/schema#advanced",
                        target: {
                            table: "therapist_session",
                            column: "Document.ClinicCode"
                        },
                        logicalOperator: "And",
                        conditions: [
                            {
                                operator: "Is",
                                value: user?.profile?.clinicCode,
                            }
                        ],
                        filterType: models.FilterType.AdvancedFilter
                    }]
                }}

                eventHandlers={
                    new Map([
                        ['rendered', () => { setLoading(false); }],
                        // ['error', function (event) { console.log(event.detail); }]
                    ])
                }

                cssClassName={styles.powerBiDashboard}
            />
        </div>
    </div>;
};

export default Dashboard;
